import {Component} from '@angular/core';
import {ViewController, NavParams, PopoverController} from 'ionic-angular';
import {DropdownPopoverPage} from '../dropdown-popover/dropdown-popover';

@Component({

  selector: 'page-dropdown-date',
  templateUrl: 'dropdown-date.html'
})

export class DropdownDatePage {

  private yrChoices = [];

  // calendar usage
  date: any;
  daysInThisMonth: any;
  daysInLastMonth: any;
  daysInNextMonth: any;
  monthNames: string[];
  currentMonth: any;
  currentYear: any;
  currentDate: any;
  valueYear: any;
  valueMonth: any;
  valueDate: any;

  private callback;


  /** ----- Constructor ----- **/

  constructor(private viewCtrl: ViewController,
              private params: NavParams,
              private popoverCtrl: PopoverController) {

    this.callback = params.get('callback');

  }


  /** ----- View LifeCycle ----- **/

  ngOnInit() {

    // default showing picked date
    this.date = new Date(this.params.get('date'));
    this.valueYear = this.date.getFullYear();
    this.valueMonth = this.date.getMonth();
    this.valueDate = this.date.getDate();
    this.monthNames = ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"];
    this.getDaysOfMonth();

  }


  /** ----- Calendar Methods ----- **/

  getDaysOfMonth() {

    this.daysInThisMonth = new Array();
    this.daysInLastMonth = new Array();
    this.daysInNextMonth = new Array();
    this.currentMonth = this.monthNames[this.date.getMonth()];
    this.currentYear = this.date.getFullYear();

    // if showing today region
    if (this.currentYear === new Date().getFullYear() &&
      this.date.getMonth() === new Date().getMonth()) {
      this.currentDate = new Date().getDate();
    } else {
      this.currentDate = 999;
    }

    var firstDayThisMonth = new Date(this.date.getFullYear(), this.date.getMonth(), 1).getDay();
    var prevNumOfDays = new Date(this.date.getFullYear(), this.date.getMonth(), 0).getDate();
    for (var i = prevNumOfDays - (firstDayThisMonth - 1); i <= prevNumOfDays; i++) {
      this.daysInLastMonth.push(i);
    }

    var thisNumOfDays = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0).getDate();
    for (var j = 0; j < thisNumOfDays; j++) {
      this.daysInThisMonth.push(j + 1);
    }

    var lastDayThisMonth = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0).getDay();
    // var nextNumOfDays = new Date(this.date.getFullYear(), this.date.getMonth()+2, 0).getDate();
    for (var k = 0; k < (6 - lastDayThisMonth); k++) {
      this.daysInNextMonth.push(k + 1);
    }
    var totalDays = this.daysInLastMonth.length + this.daysInThisMonth.length + this.daysInNextMonth.length;
    if (totalDays < 36) {
      for (var l = (7 - lastDayThisMonth); l < ((7 - lastDayThisMonth) + 7); l++) {
        this.daysInNextMonth.push(l);
      }
    }

  }


  goToLastYear() {

    this.date = new Date(this.date.getFullYear() - 1, this.date.getMonth() + 1, 0);
    this.getDaysOfMonth();

  }


  goToNextYear() {

    this.date = new Date(this.date.getFullYear() + 1, this.date.getMonth() + 1, 0);
    this.getDaysOfMonth();

  }


  goToLastMonth() {

    this.date = new Date(this.date.getFullYear(), this.date.getMonth(), 0);
    this.getDaysOfMonth();

  }


  goToNextMonth() {

    this.date = new Date(this.date.getFullYear(), this.date.getMonth() + 2, 0);
    this.getDaysOfMonth();

  }


  /** ----- UI Callback ----- **/

  onYearClicked(inEvent) {

    this.yrChoices = [];
    for (let i = new Date().getFullYear(); i >= 1900; i--) {
      this.yrChoices[this.yrChoices.length] = i;
    }
    let popover = this.popoverCtrl.create(DropdownPopoverPage, {
      'choices': this.yrChoices,
      'callback': this.yearCallback
    }, {cssClass: 'calendar-popover'});
    popover.present({
      ev: inEvent
    });
  }


  yearCallback = (inIdx) => {

    return new Promise(resolve => {

      this.date = new Date(this.yrChoices[inIdx], this.date.getMonth() + 1, 0);
      this.getDaysOfMonth();
      resolve();
    });
  };


  onMonthClicked(inEvent) {
    let popover = this.popoverCtrl.create(DropdownPopoverPage, {
      'choices': this.monthNames,
      'callback': this.monthCallback
    }, {cssClass: 'calendar-popover'});
    popover.present({
      ev: inEvent
    });
  }


  monthCallback = (inIdx) => {

    return new Promise(resolve => {

      this.date = new Date(this.date.getFullYear(), inIdx + 1, 0);
      this.getDaysOfMonth();
      resolve();
    });
  };


  onDayClick(day) {

    // this.currentDate = day;
    let apiMonth = '' + (this.monthNames.indexOf(this.currentMonth) + 1);
    apiMonth = (('' + apiMonth).length < 2) ? '0' + apiMonth : apiMonth;

    let apiDay = (('' + day).length < 2) ? '0' + day : day;

    this.callback(this.currentYear + '-' + apiMonth + '-' + apiDay).then(() => {

      this.viewCtrl.dismiss();
    });

  }

  checkYear() {
    return this.valueYear === this.currentYear;

  }


  checkMonth() {
    return this.valueMonth === this.date.getMonth();
  }


  checkDate(inDay) {
    return this.valueDate === inDay;
  }

  isPickedDate(inDay) {
    return this.checkYear() && this.checkMonth() && this.checkDate(inDay)
  }

}



// WEBPACK FOOTER //
// ./src/pages/dropdown-date/dropdown-date.ts